import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { KeyValueBlockComponent } from './key-value-block.component';
import { CopyToClipboardModule } from '../copy-to-clipboard/copy-to-clipboard.module';

@NgModule({
  declarations: [
    KeyValueBlockComponent,
  ],
  imports: [
    CommonModule,
    CopyToClipboardModule,
    IonicModule,
  ],
  exports: [
    KeyValueBlockComponent,
  ],
})
export class KeyValueBlockModule { }
